import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { customEvent } from '@utils/customEvent';

import './ListCustomComponent.less';

export default function ListCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const detailData = props.detailData;    // 详情页数据
  const dynamicData = props.dynamicData;  // 动态数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  /**
   * 单项样式
   */
  const itemStyleObj = {
    marginBottom: transformPx2Rem(data.customFeature.margin, 320),
    backgroundColor: data.customFeature.lineBackgroundColor,
    backgroundImage: data.customFeature.lineBackgroundImage,
    height: transformPx2Rem(data.customFeature.lineHeight, 320),
  };
  /**
   * 图片样式
   */
  const imgStyleObj = {
    width: transformPx2Rem(data.customFeature.imgWidth, 320),
    height: transformPx2Rem(data.customFeature.imgHeight, 320),
  };
  /**
   * 标题区域样式
   */
  const titleContainerStyleObj = {};
  if (data.customFeature.mode === 0) {
    titleContainerStyleObj['width'] = `calc(100% - ${imgStyleObj.width})`;
  }
  /**
   * 副标题样式
   */
  const secTitleStyleObj = {
    color: data.customFeature.secColor,
    fontSize: transformPx2Rem(data.customFeature.secFontSize, 320),
    fontStyle: data.customFeature.secFontStyle,
    fontWeight: data.customFeature.secFontWeight,
    textAlign: data.customFeature.secTextAlign,
    textDecoration: data.customFeature.secTextDecoration,
  };
  /**
   * 组件内容处理（TODO: 应该没有动态数据，后续删减）
   */   
  let content = data.content;
  const segment = data.customFeature.segment; // 已绑定字段
  if (dynamicData && segment) {               // 当前组件有动态数据并已绑定某字段
    content = dynamicData[segment]; // TODO: 如果content为富文本，需要处理
  }
  /**
   * 返回组件
   */ 
  return (
    <div className={`custom-component list mode-${customFeature.mode}`} style={styleObj}>
      {
        content.map((item, index) => {
          return (
            <div className="list-item" key={index} style={itemStyleObj} onClick={() => customEvent({customFeature: item.customFeature})}>
              <img style={imgStyleObj} src={item.pic} alt={item.title}/>
              <div className="title-container" style={titleContainerStyleObj}>
                <div className="title">{item.title}</div>
                <div className="sec-title" style={secTitleStyleObj}>{item.secTitle}</div>
              </div>
            </div>
          );
        })
      }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/list-custom-component/ListCustomComponent.jsx